import { MetaT } from '@global/types';

export default {
    title: 'Блог LIVECARGO: Советы для самозанятых и компаний, которые сотрудничают с плательщиками НПД',
    description:
        'Советы и рекомендации с актуальной информацией о самозанятости. Откройте эффективные стратегии оптимизации бизнес процессов',
} as MetaT;
